import React, { useEffect, useState } from "react";
import { fetchPhrases, deletePhrase } from "./adminPhraseService";
import PhraseForm from "./PhraseForm";
import "../../blog/tongueTwister.css";

const TYPES = ["PHRASE", "ABBREVIATION", "IDIOM", "PHRASAL_VERB"];
const CATEGORIES = ["EVERYDAY", "OFFICE", "ACADEMIC", "BUSINESS", "MEDICAL", "LEGAL", "TECH", "FINANCE", "TRAVEL", "SOCIAL"];
const DIFFICULTIES = ["BEGINNER", "INTERMEDIATE", "ADVANCED"];

const formatLabel = (s) => s.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

const AdminPhrasePage = () => {
 const [items, setItems] = useState([]);
 const [loading, setLoading] = useState(false);
 const [showForm, setShowForm] = useState(false);
 const [editing, setEditing] = useState(null);

 const [search, setSearch] = useState("");
 const [type, setType] = useState("");
 const [category, setCategory] = useState("");
 const [difficulty, setDifficulty] = useState("");
 const [page, setPage] = useState(0);
 const [totalPages, setTotalPages] = useState(0);

 useEffect(() => { loadItems(); }, [page, search, type, category, difficulty]);

 const loadItems = async () => {
 setLoading(true);
 const params = { page, size: 20 };
 if (search) params.search = search;
 if (type) params.type = type;
 if (category) params.category = category;
 if (difficulty) params.difficulty = difficulty;

 const res = await fetchPhrases(params);
 if (res.status === 200 && res.data) {
 const list = res.data.content || [];
 setItems(list);
 setTotalPages(res.data.totalPages || 0);
 } else {
 setItems([]);
 alert(res.message || "Failed to load");
 }
 setLoading(false);
 };

 const handleDelete = async (id) => {
 if (!window.confirm("Delete this phrase?")) return;
 const res = await deletePhrase(id);
 if (res.status === 200 || res.status === 204) {
 loadItems();
 } else {
 alert(res.message);
 }
 };

 const onSaved = () => {
 setShowForm(false);
 setEditing(null);
 loadItems();
 };

 const handleFilterChange = (setter) => (e) => {
 setPage(0);
 setter(e.target.value);
 };

 return (
 <div className="admin-container">
 <div className="admin-header">
 <h2>Phrases & Abbreviations</h2>
 <button onClick={() => { setEditing(null); setShowForm(true); }}>+ New Phrase</button>
 </div>

 {showForm && (
 <PhraseForm phrase={editing} onSaved={onSaved} onCancel={() => setShowForm(false)} />
 )}

 {/* Filters */}
 <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 20 }}>
 <input
 type="text" placeholder="Search title, meaning..."
 value={search} onChange={handleFilterChange(setSearch)}
 style={{ flex: 1, minWidth: 180, padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc" }}
 />
 <select value={type} onChange={handleFilterChange(setType)} style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc" }}>
 <option value="">All Types</option>
 {TYPES.map((t) => <option key={t} value={t}>{formatLabel(t)}</option>)}
 </select>
 <select value={category} onChange={handleFilterChange(setCategory)} style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc" }}>
 <option value="">All Categories</option>
 {CATEGORIES.map((c) => <option key={c} value={c}>{formatLabel(c)}</option>)}
 </select>
 <select value={difficulty} onChange={handleFilterChange(setDifficulty)} style={{ padding: "8px 12px", borderRadius: 6, border: "1px solid #ccc" }}>
 <option value="">All Levels</option>
 {DIFFICULTIES.map((d) => <option key={d} value={d}>{formatLabel(d)}</option>)}
 </select>
 </div>

 {loading ? (
 <p>Loading...</p>
 ) : (
 <table className="announcement-table">
 <thead>
 <tr>
 <th>Title</th>
 <th>Full Form</th>
 <th>Type</th>
 <th>Category</th>
 <th>Difficulty</th>
 <th>Sort</th>
 <th>Actions</th>
 </tr>
 </thead>
 <tbody>
 {items.length === 0 ? (
 <tr><td colSpan="7">No phrases found</td></tr>
 ) : (
 items.map((p) => (
 <tr key={p.id}>
 <td style={{ fontWeight: 600 }}>{p.title}</td>
 <td style={{ color: "#666", fontSize: 13 }}>{p.fullForm || "—"}</td>
 <td>{formatLabel(p.type)}</td>
 <td>{formatLabel(p.category)}</td>
 <td>{formatLabel(p.difficulty)}</td>
 <td style={{ textAlign: "center" }}>{p.sortOrder ?? "—"}</td>
 <td>
 <button onClick={() => { setEditing(p); setShowForm(true); }}>Edit</button>
 <button className="delete-btn" onClick={() => handleDelete(p.id)}>Delete</button>
 </td>
 </tr>
 ))
 )}
 </tbody>
 </table>
 )}

 {totalPages > 1 && (
 <div style={{ marginTop: 20 }}>
 <button disabled={page === 0} onClick={() => setPage(page - 1)}>Prev</button>
 <span style={{ margin: "0 10px" }}>Page {page + 1} / {totalPages}</span>
 <button disabled={page + 1 >= totalPages} onClick={() => setPage(page + 1)}>Next</button>
 </div>
 )}
 </div>
 );
};

export default AdminPhrasePage;
